// extracted by mini-css-extract-plugin
export default {"btop":"_28b8c9c681 _46f8435ffb c50e87dde3","icon":"_4e2563b885 da2c0bb9e7","btoppink":"e218fd7dc0 _63ad4149f7"};